import { ButtonGroup as KendoButtonGroup } from '@progress/kendo-react-buttons';

/**
 * ButtonGroup is a wrapper for the Kendo ButtonGroup component.
 *
 * @component
 * @param {Object} props - component props.
 * @param {string} [props.className] - Additional CSS classes to apply to button group.
 * @param {'ltr'|'rtl'|'auto'} [props.dir='auto'] - text direction.
 * @param {boolean} [props.disabled=false] - If true, entire button group is disabled.
 * @param {string} [props.width] - width of button group.
 * @param {React.ReactNode} props.children - child elements to render inside button group.
 * @returns {JSX.Element} rendered ButtonGroup component.
 */
export const ButtonGroup = ({
  className = '',
  dir = 'auto',
  disabled = false,
  width = '',
  children,
}) => {
  return (
    <KendoButtonGroup
      className={className}
      dir={dir}
      disabled={disabled}
      width={width}
    >
      {children}
    </KendoButtonGroup>
  );
}